// Bolla in chat per un messaggio di tipo "call" (transcript salvato dal
// webhook post-call). Il transcript resta per la memoria dell'AI, qui si
// mostra solo che la chiamata c'e' stata e quanto e' durata.
import { Phone } from "lucide-react";
import { CALL_COPY, formatCallDuration } from "./call-copy";

export function CallMessageBubble({ metadata }: { metadata: unknown }) {
  const duration = Number((metadata as any)?.durationSeconds) || 0;
  return (
    <div className="flex items-center gap-2 rounded-2xl bg-gray-100 px-4 py-2 text-sm text-gray-700">
      <Phone className="h-4 w-4 text-pink-500" />
      <span>{CALL_COPY.callMessage}</span>
      <span className="tabular-nums text-gray-500">{formatCallDuration(duration)}</span>
    </div>
  );
}
